/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var CssUtils = /** @class */ (function () {
    function CssUtils() {
    }
    CssUtils.hasClass = function (el, className) {
        return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
    };
    CssUtils.addClass = function (el, className) {
        if (!el) {
            return;
        }
        if (el.classList) {
            el.classList.add(className);
            return;
        }
        if (!CssUtils.hasClass(el, className)) {
            el.className += " " + className;
        }
    };
    CssUtils.removeClass = function (el, className) {
        if (el.classList) {
            el.classList.remove(className);
            return;
        }
        el.className = el.className.replace(new RegExp("\\b" + className + "\\b", "g"), "");
    };
    return CssUtils;
}());
export { CssUtils };
